module.exports = __webpack_public_path__ + "img/ger_true_gem_edited_v2.27d2bde5.png";